import { useGetCategoriesByEventWithBulkFallback } from '@sunrise-ui/api-client';
import { Dropdown } from '@sunrise-ui/primitives';
import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

type Props = {
  eventId: string;
  value?: string;
  onChange: (categoryId: string) => void;
  placeholder?: string;
  style?: StyleProp<ViewStyle>;
};

export function CategoryDropdown({
  eventId,
  value,
  onChange,
  placeholder = 'Select track',
  style,
}: Props) {
  const { data: categories, isLoading } =
    useGetCategoriesByEventWithBulkFallback(eventId);

  const categoryOptions =
    categories
      ?.filter((category) => category.id && category.name)
      .map((category) => ({
        label: category.name!,
        value: category.id!,
      })) || [];

  const handleClear = () => {
    onChange('');
  };

  return (
    <Dropdown
      placeholder={placeholder}
      options={categoryOptions}
      value={value}
      onChange={onChange}
      onClear={handleClear}
      buttonStyle={style}
      showLoadingState={isLoading}
    />
  );
}
